import type { FC } from "react";
import { createComponentRegistry } from "../../../../shared-logic/features/ComponentRegistry";
import type { UscTrackingLocation } from "../../utils/tracking";
import type { SimilarCarsType } from "./pdp/similar-car/SimilarCars";
import type { SidebarVariantsPropType } from "./styles/atoms/Sidebar";

const { ComponentRegistryProvider, useComponentRegistry } = createComponentRegistry<{
    Breadcrumbs: FC;
    PdpDealer: FC;
    ServicesWithDetailsList: FC;
    SaveButton: FC<{ trackingLocation: UscTrackingLocation }>;
    UscBasketCtas: FC<{ trackingLocation: UscTrackingLocation }>;
    UscFinanceOptionsButton: FC<{ trackingLocation: UscTrackingLocation }>;
    SimilarCars: FC<SimilarCarsType>;
    UscQrCode: FC;
    Sidebar: React.FC<SidebarVariantsPropType>;
}>();

export { ComponentRegistryProvider, useComponentRegistry };
